import { Loader2 } from 'lucide-react';
import { MetricCard } from '@/components/shared/MetricCard';
import { useGestionAnalytics } from '@/hooks/useGestionAnalytics';

function eur(cents: number | undefined): string {
  return ((cents || 0) / 100).toLocaleString('es-ES', {
    style: 'currency',
    currency: 'EUR',
  });
}

export function GestionAnalyticsPanel({ days }: { days: number }) {
  const { data, isLoading, error } = useGestionAnalytics(days);

  if (isLoading) return <Loader2 className="animate-spin" size={18} />;
  if (error || !data) {
    return (
      <p className="text-sm text-rose-500">
        {error instanceof Error ? error.message : 'No se pudo cargar la analítica de gestiones.'}
      </p>
    );
  }

  const lic = data.licenseOrders;
  const nav = data.navigationOrders;
  const leads = data.bluefinLeads;

  return (
    <div className="space-y-4">
      <p className="text-sm text-muted-foreground">
        Pedidos y avisos de los últimos {data.days} días. No cambia el cobro.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        <MetricCard title="Licencias (pedidos)" value={lic.total} />
        <MetricCard title="Pendientes HITL" value={lic.awaitingReview} />
        <MetricCard title="Honorarios pesca" value={eur(lic.serviceFeeCents)} format="none" />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        <MetricCard title="CHE (pedidos)" value={nav.total} />
        <MetricCard title="CHE pendientes" value={nav.awaitingReview} />
        <MetricCard title="Avisos atún" value={leads.total} />
      </div>
    </div>
  );
}
